import { memo } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Lightweight line above the table: current page row count vs server total + optional spinner.
 * Optional `endAdornment` renders on the right (e.g. batch total) on the same row when space allows.
 * Split out so summary updates do not rebuild the filter bar or other siblings.
 */
function QcTaskAssignmentsSummaryComponent({
  rowsLength,
  rowCount,
  loading,
  endAdornment,
}) {
  return (
    <Typography
      variant="caption"
      component="div"
      sx={{
        color: 'text.secondary',
        m: 0,
        p: 0,
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        columnGap: { xs: 0.5, sm: 1, md: 1.25 },
        rowGap: 0,
        width: '100%',
        fontSize: { xs: '0.65rem', sm: '0.7rem', md: '0.8125rem' },
        lineHeight: 2.5,
        letterSpacing: 0.01,
      }}
    >
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          flexWrap: 'nowrap',
          alignItems: 'center',
          columnGap: { xs: 0.35, sm: 0.5 },
          minWidth: 0,
        }}
      >
        <span>
          Showing {rowsLength} of {rowCount} task(s)
        </span>
        {loading ? (
          <CircularProgress
            size={10}
            thickness={5}
            sx={{ flexShrink: 0 }}
            aria-label="Loading assignments"
          />
        ) : null}
      </Box>
      {endAdornment ? (
        <Box
          component="span"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            flexShrink: 0,
            pl: { xs: 0.5, sm: 1 },
          }}
        >
          {endAdornment}
        </Box>
      ) : null}
    </Typography>
  );
}

export default memo(QcTaskAssignmentsSummaryComponent);
